export default __webpack_public_path__ + "static/marketbg-076d5a84c7ce8639ff537678b09f902b.png";